import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isSubmit: false,
    isFail: false,
    isGetItem: false,
    isFetchingUpdate: false,
    forceMfaUpdatingIds: [],
    csUsers: [],
    data: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.USER_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.USER_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.USER_GET_CS_USER_ACTION:
            return { ...state, isFetching: true };
        case Types.USER_GET_CS_USER_SUCCESS:
            return { ...state, isFetching: false, csUsers: action.csUsers };
        case Types.USER_GET_CUSTOMER_USER_ACTION:
            return { ...state, isFetching: true };
        case Types.USER_GET_CUSTOMER_USER_SUCCESS:
            return { ...state, isFetching: false, csUsers: action.customerUsers };
        case Types.USER_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.USER_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.USER_FORCE_MFA_UPDATE_ACTION:
            return {
                ...state,
                forceMfaUpdatingIds: Array.from(new Set([
                    ...(state.forceMfaUpdatingIds || []),
                    action.params.id,
                ])),
            };
        case Types.USER_FORCE_MFA_UPDATE_SUCCESS:
            return {
                ...state,
                forceMfaUpdatingIds: (state.forceMfaUpdatingIds || []).filter(id => id !== action.params.id),
                data: {
                    ...state.data,
                    result: (state.data.result || []).map(user => user.id === action.params.id
                        ? { ...user, forceMfa: action.params.forceMfa }
                        : user),
                },
                dataUpdate: state.dataUpdate && state.dataUpdate.id === action.params.id
                    ? { ...state.dataUpdate, forceMfa: action.params.forceMfa }
                    : state.dataUpdate,
            };
        case Types.USER_FORCE_MFA_UPDATE_FAIL:
            return {
                ...state,
                forceMfaUpdatingIds: (state.forceMfaUpdatingIds || []).filter(id => id !== action.params.id),
            };
        case Types.USER_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.USER_LIST_SUCCESS:
            return { ...state, isFetching: false, data: action.users, isSubmit: false };
        case Types.USER_GET_UPDATE_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataUpdate: action.dataUpdate };
        case Types.USER_GET_ROLE_SUCCESS:
            return { ...state, roleUser: action.roleUser };
        case Types.USER_CHANGE_PASSWORD_ACTION:
            return { ...state, isFetching: true, }
        case Types.USER_CHANGE_PASSWORD_SUCCESS:
            return { ...state, isFetching: false }
        case Types.USER_CHANGE_PASSWORD_FAIL:
            return { ...state, isFetching: false }
        case Types.USER_FAIL:
            return { ...state, isFetching: false, isSubmit: false }
        default:
            return state;
    }
}
